import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'
import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { DashboardComponent } from 'experiences/dashboard/DashboardRoot'

const Dashboard: NextPage<PageProps> = ({ metaTags }) => (
	<StandardLayout metaTags={metaTags}>
		<DashboardLayout ssrDisplay={true}>
			<DashboardComponent />
		</DashboardLayout>
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default Dashboard
